/**
 * ResizableDivider - Draggable divider between panels
 */

import { useState, useEffect, useCallback } from 'react';

interface ResizableDividerProps {
  onResize: (deltaPercent: number) => void;
}

export default function ResizableDivider({ onResize }: ResizableDividerProps) {
  const [dragging, setDragging] = useState(false);
  const [startX, setStartX] = useState(0);

  const handleMouseDown = useCallback((e: React.MouseEvent) => {
    setDragging(true);
    setStartX(e.clientX);
    e.preventDefault();
  }, []);

  useEffect(() => {
    if (!dragging) return;

    const handleMouseMove = (e: MouseEvent) => {
      const containerWidth = window.innerWidth;
      const deltaX = e.clientX - startX;
      const deltaPercent = (deltaX / containerWidth) * 100;
      onResize(deltaPercent);
      setStartX(e.clientX);
    };

    const handleMouseUp = () => {
      setDragging(false);
    };

    window.addEventListener('mousemove', handleMouseMove);
    window.addEventListener('mouseup', handleMouseUp);

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mouseup', handleMouseUp);
    };
  }, [dragging, startX, onResize]);

  return (
    <div
      className={`
        w-1 flex-shrink-0 cursor-col-resize transition-colors
        ${dragging ? 'bg-blue-500' : 'bg-gray-700 hover:bg-gray-600'}
      `}
      onMouseDown={handleMouseDown}
    />
  );
}
